const baseURL = "/v1/Profissional/Termo";

const service = {
  methods: {
    $obterTermo(params) {
      return this.$api().get(`${baseURL}/ObterTermo`, params);
    },
    $aceitarTermo(body) {
      return this.$api().post(`${baseURL}/Aceitar`, body);
    },
  },
};

export default service;
